<div class="d-inline-block ms-2" stopClickPropagation preventDefault ngbDropdown>
  <button ngbDropdownToggle class="btn btn-sm btn-secondary">{{ statusNames[getStatus()][language] }} <i class="fa-solid fa-chevron-down ms-2"></i></button>
  <div ngbDropdownMenu>
    <div class="clickable" (click)="updateStatus('undecided');" ngbDropdownItem>
      {{ texts.statusNames.undecided[language] }}
    </div>
    <div class="clickable" (click)="updateStatus('accepted');" ngbDropdownItem>
      {{ texts.statusNames.accepted[language] }}
    </div>
    <div class="clickable" (click)="updateStatus('rejected');" ngbDropdownItem>
      {{ texts.statusNames.rejected[language] }}
    </div>
  </div>
</div>
